import React from "react";
import "./styles.scss";
import {Col, Container, Row} from "react-bootstrap";
import {Route, Switch} from "react-router-dom";
import SubMenu from "../../components/side-nav-bar/sub-menus";
import AnnoucementMenuItems
  from "../../components/side-nav-bar/sub-menus/containers/announcements/containers/AnnoucementMenuItems";
import AnnouncementViewAdmin from "./announcement-view/AnnouncementViewAdmin";
import AnnouncementsAdmin from "./announcements/AnnouncementsAdmin";
import CreateAnnouncement from "./create-announcement/CreateAnnouncement";
import UpdateAnnouncement from "./update-announcement/UpdateAnnouncement";

export enum DashboardAnnouncementsPages {
  ANNOUNCEMENTS = "/dashboard/announcements",
  ANNOUNCEMENT = "/dashboard/announcements/announcement/:id",
  CREATE_ANNOUNCEMENT = "/dashboard/announcements/newannouncement",
  UPDATE_ANNOUNCEMENT = "/dashboard/announcements/editannouncement/:id",
}

const AnnouncementRoutes = () => {
  return (
    <div className="announcement-admin-wrapper">
      <SubMenu>
        <AnnoucementMenuItems/>
      </SubMenu>
      <Container fluid className="course-wrapper pt-0">
        <Row>
          <Col md={12} lg={12} sm={12}>
            <Switch>
              <Route exact path={DashboardAnnouncementsPages.ANNOUNCEMENTS}>
                <AnnouncementsAdmin/>
              </Route>
              <Route
                exact
                path={DashboardAnnouncementsPages.CREATE_ANNOUNCEMENT}
              >
                <CreateAnnouncement/>
              </Route>
              <Route
                exact
                path={DashboardAnnouncementsPages.UPDATE_ANNOUNCEMENT}
              >
                <UpdateAnnouncement/>
              </Route>
              <Route exact path={DashboardAnnouncementsPages.ANNOUNCEMENT}>
                <AnnouncementViewAdmin/>
              </Route>
            </Switch>
          </Col>
          <Col md={3} lg={2} style={{borderLeft: "solid 1px #333"}}/>
        </Row>
      </Container>
    </div>
  );
};

export default AnnouncementRoutes;
